import PhotoSearchUpgradeCheckout from './PhotoSearchUpgradeCheckout';

export default PhotoSearchUpgradeCheckout;
